import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import sshLogo from '../../assets/images/ssh.png';
const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <div>
                            <img src={sshLogo} alt="ssh logo" className="SSH_logo" />
                        </div>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;
